import { RouteLayout } from 'shared/components/layouts';

import { MembersContent } from '../components';

export function MembersPage() {
  return <RouteLayout content={<MembersContent />} />;
}
